export default {
  market_qryEnterpriseInformation: {
    control: 'dyc/saas/common/user/noauth/qryEnterpriseInformation'
  },
  market_authQryEnterpriseInformation: {
    control: 'dyc/saas/common/user/qryEnterpriseInformation'
  },
  market_registerAccount: {
    control: 'dyc/saas/common/user/market/buyer/noauth/registerAccount'
  }
};